import { GooglePlaceResult } from "../schema";

export function convertPlace(place: GooglePlaceResult) {
  return {
    id: place.id,
    location: {
      lat: place.location.lat(),
      lng: place.location.lng(),
    },
    display_name: place.displayName,
    photos: place.photos.map((photo) => ({
      author_attributions: photo.authorAttributions?.map((author) => ({
        display_name: author.displayName,
        photo_uri: author.photoURI,
        uri: author.uri,
      })),
      url: photo.getURI({ maxWidth: 1000 }),
    })),
    rating: place.rating,
    user_rating_count: place.userRatingCount,
    formatted_address: place.formattedAddress,
    price_level: place.priceLevel,
    primary_type_display_name: place.primaryTypeDisplayName,
    website_uri: place.websiteURI,
    google_maps_uri: place.googleMapsURI,
    business_status: place.businessStatus,
    international_phone_number: place.internationalPhoneNumber,
    address_components: place.addressComponents,
  };
}
